import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSidebarStore = defineStore('sidebar', {
  state: () => ({
    sidebarVisibleStore: ref(false),
    sidebarVisibleAdmin: ref(false)
  }),
  getters: {
    isSidebarVisibleStore: (state) => state.sidebarVisibleStore,
    isSidebarVisibleAdmin: (state) => state.sidebarVisibleAdmin
  },
  actions: {
    toggleSidebarStore() {
      this.sidebarVisibleStore = !this.sidebarVisibleStore
    },
    toggleSidebarAdmin() {
      this.sidebarVisibleAdmin = !this.sidebarVisibleAdmin
    },
    setSidebarVisibleStore(value) {
      this.sidebarVisibleStore = value
    },
    setSidebarVisibleAdmin(value) {
      this.sidebarVisibleAdmin = value
    }
  },
  persist: true
})
